import dayjs from "dayjs";
/**
 * 深度克隆对象
 * @param {Object} obj
 * @returns {Object}
 */
export function deepClone(obj) {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }
  const newObj = Array.isArray(obj) ? [] : {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      newObj[key] = typeof obj[key] === 'object' ? deepClone(obj[key]) : obj[key];
    }
  }
  return newObj;
}


/**
 * 节流函数
 * @param {Function} func
 * @param {Number} wait
 * @returns {Function}
 */
export function throttle(func, wait) {
  let previous = 0;
  return function () {
    const now = Date.now();
    if (now - previous > wait) {
      func.apply(this, arguments);
      previous = now;
    }
  };
}

/**
 * 防抖函数
 * @param {Function} func
 * @param {Number} wait
 * @returns {Function}
 */
export function debounce(func, wait) {
  let timeout;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      func.apply(context, args);
    }, wait);
  };
}

/**
 * 判断是否是移动端
 * @returns {Boolean}
 */
export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

/**
 * 判断是否是安卓浏览器
 * @returns {Boolean}
 */
export function isAndroid() {
  return /Android/i.test(navigator.userAgent);
}

/**
 * 判断是否是苹果浏览器
 * @returns {Boolean}
 */
export function isIOS() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

/**
 * 判断是否是微信浏览器
 * @returns {Boolean}
 */
export function isWeixin() {
  return /MicroMessenger/i.test(navigator.userAgent);
}

/**
 * 监听localStorage切换
 * @returns {Boolean}
 */
export default function dispatchEventStroage() {
	const signSetItem = localStorage.setItem
	localStorage.setItem = function (key, val) {
		let setEvent = new Event('setItemEvent')
		setEvent.key = key
		setEvent.newValue = val
		window.dispatchEvent(setEvent)
		// eslint-disable-next-line prefer-rest-params
		signSetItem.apply(this, arguments)
	}
}

export function setTime(time) {
  return dayjs(Number(time)).format("YYYY-MM-DD")
}

